import React from "react";
import { query, collection, where } from "firebase/firestore";
import { db } from "../api/firebase";
import GroupTable from "./GroupTable";
import { useCollection } from "react-firebase-hooks/firestore";

const PendingGroups = () => {
  const q = query(collection(db, "group"), where("isPublish", "==", false));
  //   承認待ち
  const [pendingCollection] = useCollection(q);
  const pending = pendingCollection?.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));

  return (
    <>
      <div className="mb-12">
        <div className="font-bold text-2xl">
          承認待ちグループ{pending?.length > 0 ? ":" + pending?.length : ""}
        </div>
        {pending?.length ? (
          <GroupTable pending={pending} />
        ) : (
          <div className="text-gray-400 text-sm pl-5">
            承認待ちグループはありません
          </div>
        )}
      </div>
    </>
  );
};

export default PendingGroups;
